import {Center, Flex, Image, Text} from '@chakra-ui/react'
import {Progress} from 'antd'
import {
  getScoreWrap,
  getColorByScore,
  getColorGradientByScore,
} from './utilsExamResult'
import {useSelector} from 'react-redux'

const BandScore = () => {
  const {dataExamResult} = useSelector((state: any) => state.examResult)

  const scoreDemo = [
    {
      label: 'Trôi chảy',
      score: dataExamResult?.statistics?.fluency,
    },
    {
      label: 'Từ vựng',
      score: dataExamResult?.statistics?.vocabulary,
    },
    {
      label: 'Ngữ pháp',
      score: dataExamResult?.statistics?.grammar,
    },
    {
      label: 'Phát âm',
      score: dataExamResult?.statistics?.pronunciation,
    },
  ]

  return (
    <Flex
      gap={{base: '16px', md: '32px'}}
      mt={{base: '16px', md: '32px'}}
      flexDirection={{base: 'column', lg: 'row'}}>
      <Center bg={'white'} borderRadius={'20px'} p={'16px'} position="relative">
        <Image
          src={getScoreWrap(dataExamResult?.statistics?.overall)}
          w={{base: '250px', md: '350px'}}
        />
        <Text
          fontSize={{base: '50px', md: '75px'}}
          color={'white'}
          fontWeight={700}
          position={'absolute'}
          letterSpacing={'0px'}
          bottom={'44%'}>
          {dataExamResult?.statistics?.overall.toFixed(1)}
        </Text>
      </Center>
      <Flex
        flex={1}
        p={{base: '16px', md: '60px'}}
        bg={'white'}
        borderRadius={'20px'}
        flexDirection={'column'}
        justifyContent={'space-between'}
        gap={'8px'}>
        {scoreDemo.map((item: any, index: any) => {
          return (
            <Flex key={index} gap={'12px'} alignItems={'center'}>
              <Text
                w={'150px'}
                fontSize={{base: '16px', md: '24px'}}
                fontWeight={700}>
                {item.label}
              </Text>
              <Progress
                percent={item.score * 10}
                showInfo={false}
                size={['', 20]}
                strokeColor={getColorGradientByScore(item.score)}
              />
              <Text
                fontSize={{base: '16px', md: '24px'}}
                color={getColorByScore(item.score)}
                fontWeight={700}>
                {item.score}
              </Text>
            </Flex>
          )
        })}
      </Flex>
    </Flex>
  )
}

export default BandScore
